const Footer = () => {


    return (
        <section className="expanded-width footer">
            <p>© 2023 South Movies. All rights reserved.</p>
        </section>
    )
}

export default Footer